export enum OrderPaymentsEnum {
    FULL_PAYMENT = "fullPayment",
    DEPOSIT = "deposit",
}
